export const SETTHEME = {
  token: {
    colorPrimary: "#936f42", // 主题颜色
    colorLink: "#936f42", // 超链接颜色
  },
};
